import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [profile, setProfile] = useState(null);
  const [member,  setMember]  = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) loadProfile(session.user.id);
      else setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setSession(session);
      if (session) loadProfile(session.user.id);
      else { setProfile(null); setMember(null); setLoading(false); }
    });
    return () => subscription.unsubscribe();
  }, []);

  async function loadProfile(userId) {
    const { data } = await supabase
      .from('users')
      .select('*, members(*, districts:district_id(id, name), families(name, id))')
      .eq('id', userId)
      .single();
    if (data) { setProfile(data); setMember(data.members); }
    setLoading(false);
  }

  async function signIn(identifier, password) {
    // Try email first, then phone lookup
    const isEmail = identifier.includes('@');
    let email = identifier;

    if (!isEmail) {
      // Look up user by phone to get their email
      const { data: user } = await supabase
        .from('users')
        .select('email')
        .eq('phone', identifier)
        .maybeSingle();
      if (!user?.email) return { error: { message: 'Account not found' } };
      email = user.email;
    }

    const result = await supabase.auth.signInWithPassword({ email, password });

    // Update last_login
    if (result.data?.user) {
      await supabase.from('users').update({ last_login: new Date().toISOString() }).eq('id', result.data.user.id);
    }
    return result;
  }

  async function signOut() {
    await supabase.auth.signOut();
    setProfile(null); setMember(null);
  }

  const role      = profile?.role;
  const isAdmin   = ['super_admin','finance_admin','evangelist_admin'].includes(role);
  const isFinance = ['super_admin','finance_admin'].includes(role);
  const isEvang   = ['super_admin','evangelist_admin'].includes(role);
  const isGroup   = role === 'group_leader';
  const isMember  = role === 'member';

  return (
    <AuthContext.Provider value={{ session, profile, member, loading, role, isAdmin, isFinance, isEvang, isGroup, isMember, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
